import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-150" data-mp="hvgl64lgx6wp">
      <div className="mx-auto max-w-6xl" data-id="element-151" data-mp="3zv20e1x1hc7">
        <SectionHeading id="volumes-heading" title={<>
              Das steckt in <Accent data-id="element-153" data-mp="voodjyhdi6fg">NAIL EDUCATOR READY™</Accent>
            </>} data-id="element-152" data-mp="7yu47qw9izzy" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-154" data-mp="10okibzxwa1w2">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(78,49,108,0.45)]" data-id="element-155" data-mp="mvl5y6tesnsq">
              <div className="flex min-h-[150px] flex-col px-6 pb-6 pt-5" style={{
            backgroundColor: volume.accent
          }} data-id="element-156" data-mp="1emr6god1knij">
                <span className="self-start rounded-full bg-white/70 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-157" data-mp="1jg3ilz0jb1ue">
                  Band {volume.number}
                </span>
                <h3 className="mt-auto pt-5 font-display text-[1.4rem] font-bold leading-[1.12] text-brand-charcoal" data-id="element-158" data-mp="7kbv96cjcg3k">
                  {volume.title}
                </h3>
              </div>
              <p className="flex-1 px-6 py-5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-159" data-mp="hi9lfzdygmyt">{volume.description}</p>
            </li>)}
        </ol>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-160" data-mp="r949n9arhwmw">
          Von der fachlichen Grundlage bis zur Unterrichtsgestaltung – <Accent data-id="element-161" data-mp="10c59wtcy4tin">alles in einer digitalen Sammlung.</Accent>
        </p>
      </div>
    </section>;
}